import passsportLogo from '../assets/passsport-logo-hd.png';

export type Partner = {
    id: string;
    name: string;
    logo: string;
    url?: string;
};

export const PARTNERS: Partner[] = [
    {
        id: 'passsport',
        name: 'Passsport',
        logo: passsportLogo,
    },
];
